import React from "react";
import PropTypes from "prop-types";
// @mui imports
import MuiGrid from "@mui/material/Grid";
const Grid = ({
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(MuiGrid, rest, children);
};
export default Grid;
Grid.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};